import { View, Text, FlatList, Button } from "react-native";
import React, { useEffect, useState } from "react";
const { convertXML } = require("simple-xml-to-json");
import { auth, db } from "../firebase.js";
import { setDoc, doc, getDocs, collection } from "firebase/firestore";

const XML = () => {
  const [productos, setProductos] = useState([]);

  const alta = () => {
    console.log("estoy pasando");
    for (let i = 0; i < productos.length; i++) {
      setDoc(
        doc(
          db,
          "ProductosDRN",
          productos[i].productosweb.children[0].ARTICULO__ID.content
        ),
        {
          sku: productos[i].productosweb.children[0].ARTICULO__ID.content,
          nombre: productos[i].productosweb.children[1].DENOMINACION.content,
          familia: productos[i].productosweb.children[4].FAMILIA.content,
          subfamilia: productos[i].productosweb.children[6].SUBFAMILIA.content,
          tipo: productos[i].productosweb.children[8].TIPO.content,
          stock: productos[i].productosweb.children[9].STOCK.content,
          precio: productos[i].productosweb.children[10].PRECIOVENTA.content,
        }
      );
      console.log(i);
    }
  };

  useEffect(() => {
    console.log("mejecu");
    var xhr = new XMLHttpRequest(); //invocar nueva instancia de XMLHttpRequest
    xhr.onload = exito; // llamar a la funcion exito si exitosa
    xhr.onerror = error; // llamar a la funcion error si fallida
    xhr.open(
      "GET",
      "http://sa08.ddns.net:7780/AppAndroid/servlet/ServletAndroid?empresa=ero&usuario=consultaweb&clave=web3007&dato=productoswebestandarsiniva"
    ); // Abrir solicitud GET
    xhr.send();
  }, []);
  function exito() {
    var datos = this.responseText;

    // parseString(datos, { mergeAttrs: true }, (err, result) => {
    //   console.log(result.vdato.productosweb);
    //   setProductos(result.vdato.productosweb);
    // });

    const myJson = convertXML(datos);
    setProductos(myJson.vdato.children);
    console.log(myJson.vdato.children);
    console.log("nombre");
    console.log(
      myJson.vdato.children[0].productosweb.children[1].DENOMINACION.content
    );
    console.log("sku");
    console.log(
      myJson.vdato.children[0].productosweb.children[0].ARTICULO__ID.content
    );
    console.log("familia");
    console.log(
      myJson.vdato.children[0].productosweb.children[4].FAMILIA.content
    );
    console.log("familiaID");
    console.log(
      myJson.vdato.children[0].productosweb.children[3].FAMILIA__ID.content
    );
    console.log("subfamilia");
    console.log(
      myJson.vdato.children[0].productosweb.children[6].SUBFAMILIA.content
    );
    console.log("subfamiliaID");
    console.log(
      myJson.vdato.children[0].productosweb.children[5].SUBFAMILIA__ID.content
    );
    console.log("tipo");
    console.log(myJson.vdato.children[0].productosweb.children[8].TIPO.content);
    console.log("tipoID");
    console.log(
      myJson.vdato.children[0].productosweb.children[7].TIPO__ID.content
    );
    console.log("Stock");
    console.log(
      myJson.vdato.children[0].productosweb.children[9].STOCK.content
    );
    console.log("Precio");
    console.log(
      myJson.vdato.children[0].productosweb.children[10].PRECIOVENTA.content
    );

    console.log(
      myJson.vdato.children[0].productosweb.children[1].DENOMINACION.content
    );
  }

  // funcion para la llamada fallida
  function error(err) {
    console.log("Solicitud fallida", err); //los detalles en el objecto "err"
  }

  console.log("hola");
  return (
    <View>
      <Text>XML</Text>
      <FlatList
        data={productos}
        renderItem={({ item }) => (
          <Text>. {item.productosweb.children[1].DENOMINACION.content}</Text>
        )}
      />
    </View>
  );
};

export default XML;
